<div style="height:422px; overflow-y:scroll">
    <div class="font-size-16 pt-2 px-3">Assigned to:</div>

    <div class="pb-2 pl-4 pr-3">
        <div class="lato-bold font-size-16 pt-3 pb-1" cvLocalizedText langSection="Objectives" langKey="Employee_Groups">Employee Group(s)</div>
        <div class="py-1 px-2" *ngIf="(showall || empAssignAll) && !empSelected()" cvLocalizedText langSection="Objectives" langKey="All_Emp_Groups">All Emp Groups</div>
        <div class="py-1 px-2" style="color:#DC3545" *ngIf="!showall && !empSelected() && !empAssignAll" cvLocalizedText langSection="Objectives" langKey="Select_Groups">*Select at least one group</div>

        <div class="assignRowHover hoverContainer d-flex justify-content-between align-items-center" *ngFor="let obj of filteredLst(0)">
            <div class="txtOverflow py-1 pl-2 pr-1" style="flex:1">- {{obj.GroupName}}</div>
            <div class="pr-1" *ngIf="showall && obj.GroupLevel > 1">{{'(' + obj.totalGroupCount + ' Groups)'}}</div>

            <div style="width:24px">
                <button type="button" class="buttonHover icon-btn" hidden (click)="onRemove(obj)">
                    <img src="../App_Themes/clearview-default/icons/utility/remove-16px.svg">
                </button>
            </div>
        </div>

        <div class="lato-bold font-size-16 pt-3 pb-1" cvLocalizedText langSection="Objectives" langKey="Call_Groups">Call Group(s)</div>
        <div class="py-1 px-2" *ngIf="(showall || recAssignAll) && !recSelected()" cvLocalizedText langSection="Objectives" langKey="All_Emp_Groups">All Rec Groups</div>
        <div class="py-1 px-2" style="color:#DC3545" *ngIf="!showall && !recSelected() && !recAssignAll" cvLocalizedText langSection="Objectives" langKey="Select_Groups">*Select at least one group</div>

        <div class="assignRowHover hoverContainer d-flex justify-content-between align-items-center" *ngFor="let obj of filteredLst(1)">
            <div class="txtOverflow py-1 pl-2 pr-1" style="flex:1">- {{obj.GroupName}}</div>
            <div class="pr-1" *ngIf="showall && obj.GroupLevel > 1">{{'(' + obj.totalGroupCount + ' Groups)'}}</div>

            <div style="width:24px">
                <button type="button" class="buttonHover icon-btn" hidden (click)="onRemove(obj)">
                    <img src="../App_Themes/clearview-default/icons/utility/remove-16px.svg">
                </button>
            </div>
        </div>

        <div class="lato-bold font-size-16 pt-3 pb-1">
            <span cvLocalizedText langSection="Objectives" langKey="Attributes">Attribute(s)</span> <span class="color-valyrianSteel lato-regular" cvLocalizedText langSection="Objectives" langKey="Optional">(Optional)</span>
        </div>

        <div class="assignRowHover hoverContainer d-flex justify-content-between align-items-center" *ngFor="let obj of filteredLst(2)">
            <div class="txtOverflow py-1 pl-2 pr-1">- {{obj.AttributeValueName}}</div>

            <div style="width:24px">
                <button type="button" class="buttonHover icon-btn" hidden (click)="onRemove(obj)">
                    <img src="../App_Themes/clearview-default/icons/utility/remove-16px.svg">
                </button>
            </div>
        </div>
    </div>
</div>
